import React, { Fragment, useState, useRef } from 'react'
import { Slide, Box, Typography } from '@material-ui/core'
import useStyles from './styles'
import { useSelector, useDispatch } from 'react-redux'
import Streamer from 'components/Streamer'
import { useEffect } from 'react'
import { updateStream } from 'actions/stream'
import { createStream } from 'actions/stream'
import { getStreamStats } from 'actions/stream'
import { makeStreamLive } from 'actions/stream'
import PubnubController from 'components/PubnubController'
import AllowLiveDialog from './allowLiveDialog'
import WaitingDialog from './waitingDialog'
import LoaderButton from 'components/LoaderButton'
import { openSnackBar } from 'actions/snack-bar'
import { getEvent } from 'actions/event'
import { setStream } from 'actions/stream'
import SetNameDialog from './setNameDialog'
import { isEmpty } from 'lodash'
import { updateEventStreams } from 'actions/event'
import classnames from 'clsx'
import LoginDialog from 'dialogs/Login'
import { openDialog } from 'actions/dialogs'
import Captions from './captions'

// Hook
function useWindowSize() {
  // Initialize state with undefined width/height so server and client renders match
  // Learn more here: https://joshwcomeau.com/react/the-perils-of-rehydration/
  const [windowSize, setWindowSize] = useState({
    width: undefined,
    height: undefined
  })

  useEffect(() => {
    // Handler to call on window resize
    function handleResize() {
      // Set window width/height to state
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight
      })
    }

    // Add event listener
    window.addEventListener('resize', handleResize)

    // Call handler right away so state gets updated with initial window size
    handleResize()

    // Remove event listener on cleanup
    return () => window.removeEventListener('resize', handleResize)
  }, []) // Empty array ensures that effect is only run on mount

  return windowSize
}

const Stream = ({ match }) => {
  const classes = useStyles()
  const pubnub = useRef(null)
  const streamPubnub = useRef(null)
  const [streamRef, setStreamRef] = useState(null)
  const [streamPubnubCount, setStreamPubnubCount] = useState(0)
  const streamName = useSelector(state => state.stream.name)
  const packetLoss = useSelector(state => state.stream.packetLost)

  const numViewers = useSelector(state => state.stream.numViewers)
  const frameRate = useSelector(state => state.stream.frameRate)
  const bitrateSent = useSelector(state => state.stream.bitrateSent)
  const totalVideoPackets = useSelector(state => state.stream.totalVideoPackets)
  const totalAudioPackets = useSelector(state => state.stream.totalAudioPackets)
  //console.log(packetLoss)
  const event = useSelector(state => state.event.event)
  const authenticatedUser = useSelector(
    state => state.authentication.authenticatedUser
  )
  const { eventId } = match.params
  const [requestUser, setRequestUser] = useState('')
  const [requestStreamId, setRequestStreamId] = useState(0)
  const [streamId, setStreamId] = useState(0)
  const [streamUUID, setStreamUUID] = useState(null)
  const [allowLiveDialogOpen, setAllowLiveDialogOpen] = useState(false)
  const [waitingDialogOpen, setWaitingDialogOpen] = useState(false)
  const [liveRequested, setLiveRequested] = useState(false)
  const dispatch = useDispatch()
  const windowSize = useWindowSize()

  const myStream =
    event.live_url_data && event.live_url_data.find(x => x.url === streamUUID)
  const isStreaming =
    event.live_url_data && event.live_url_data.find(x => x.live_now)

  const startStream = () => {
    streamRef.startPublishing()
  }

  const stopStream = () => {
    setLiveRequested(true)
    if (myStream) {
      dispatch(
        makeStreamLive(myStream.id, event.auction_code, {
          live_now: 0
        })
      )
        .catch(() => {
          dispatch(openSnackBar({ message: 'Error stopping stream' }))
        })
        .finally(() => {
          setLiveRequested(false)
        })
    } else {
      console.error('no stream')
      // dispatch(openSnackBar({ message: "Could not access camera"}))
    }
  }

  useEffect(() => {
    if (eventId) {
      dispatch(getEvent(eventId)).catch(err => {
        console.log(err)
        if (err && err.status && err.status === 401) {
          localStorage.clear()
          dispatch({ type: 'RESET_STORE' })
        }
        dispatch(openSnackBar({ message: 'Error loading event' }))
        // setTimeout(() => {
        //   window.location.reload()
        // }, 1000)
      })
    }
  }, [eventId])

  useEffect(() => {
    if (streamName) {
      startStream()
    }
  }, [streamName])

  useEffect(() => {
    if (!navigator.mediaDevices || !navigator.mediaDevices.enumerateDevices) {
      dispatch(
        openSnackBar({
          message: 'Your current browser does not support streaming'
        })
      )
    } else {
      navigator.mediaDevices
        .enumerateDevices()
        .then(res => {
          if (isEmpty(authenticatedUser)) {
            dispatch(openDialog('login'))
          } else {
            dispatch(setStream({ nameDialogOpen: true }))
          }
          // setIsStreaming(true)
        })
        .catch(err => {
          dispatch(
            openSnackBar({
              message: 'Your current browser does not support streaming'
            })
          )
        })
    }
  }, [])

  useEffect(() => {
    if (!isEmpty(authenticatedUser)) {
      dispatch(setStream({ nameDialogOpen: true }))
    }
  }, [authenticatedUser])

  const handlePublish = uuid => {
    console.log('handle publish', uuid)
    setStreamUUID(uuid)
    dispatch(updateStream(uuid, { name: streamName })).then(res => {
      return dispatch(
        createStream(event.auction_code, {
          url: uuid,
          label: streamName,
          type: 'eglive',
          type_detail: '{}'
        })
      )
    })
  }

  const askToGoLive = () => {
    if (myStream) {
      setLiveRequested(true)
      if (isStreaming) {
        // ask to go live
        setWaitingDialogOpen(true)
        pubnub.current.publish({
          action: 'requestGoLive',
          data: {
            streamId: myStream.id,
            event_id: event.auction_code,
            requestUser: streamName
          }
        })
      } else {
        //console.log(myStream)
        // make it live
        dispatch(
          makeStreamLive(myStream.id, event.auction_code, {
            live_now: 1
          })
        )
          .catch(() => {
            dispatch(openSnackBar({ message: 'Error starting stream' }))
          })
          .finally(() => {
            setLiveRequested(false)
          })
      }
    } else {
      console.error('no stream')
      dispatch(openSnackBar({ message: 'Could not access device camera' }))
    }
  }

  const handleCancelRequest = () => {
    setWaitingDialogOpen(false)
    setLiveRequested(false)
    pubnub.current.publish({
      action: 'cancelGoLiveRequest',
      data: {}
    })
  }

  const handlePubnub = data => {
    const streamData = data.data
    if (typeof myStream !== 'undefined') {
      dispatch(getStreamStats(myStream.url))
    }
    if (data.action === 'requestGoLive') {
      if (myStream.live_now) {
        setAllowLiveDialogOpen(true)
        setRequestUser(streamData.requestUser)
        setRequestStreamId(streamData.streamId)
      }
    } else if (data.action === 'cancelGoLiveRequest') {
      setLiveRequested(false)
      setAllowLiveDialogOpen(false)
      setWaitingDialogOpen(false)
      setRequestUser('')
      setRequestStreamId(0)
    } else if (data.action === 'updateStreams') {
      dispatch(updateEventStreams(streamData))
    }
  }

  const handleStreamPresence = data => {
    if (data && data.occupancy) {
      setStreamPubnubCount(data.occupancy)
    }

    if (data.occupancy < streamPubnubCount) {
      dispatch(getEvent(event.auction_code)).catch(err => {
        console.log(err)
      })
      console.log('lost a stream')
    }
  }

  const streaming = myStream && isStreaming && myStream.id === isStreaming.id
  const be100 = windowSize.width < 500
  return (
    <Fragment>
      <Captions stream={myStream} />
      <Box className={classes.goLiveContainer}>
        <div className={classes.topSection}>
          <Typography style={{ color: 'white', fontSize: '14px' }}>
            Currently streaming
          </Typography>
          <Box display="flex" alignItems="center">
            <div className={isStreaming ? classes.greenDot : classes.greyDot} />
            <Typography style={{ color: 'white' }} variant="h3">
              {isStreaming ? `${isStreaming.label}` : 'No current stream'}
            </Typography>
          </Box>
          <Typography style={{ color: 'white', fontSize: '14px' }}>
            Total Viewers: {numViewers}
          </Typography>
          <Typography style={{ color: 'white', fontSize: '14px' }}>
            Frames per Second: {frameRate}
          </Typography>
          <Typography style={{ color: 'white', fontSize: '14px' }}>
            Bitrate: {bitrateSent}
          </Typography>
          <Typography style={{ color: 'white', fontSize: '14px' }}>
            Total Video Packets: {totalVideoPackets}
          </Typography>
          <Typography style={{ color: 'white', fontSize: '14px' }}>
            Total Audio Packets: {totalAudioPackets}
          </Typography>
        </div>
        <Streamer
          streamName={streamName}
          useRef={ref => setStreamRef(ref)}
          onPublish={uuid => {
            handlePublish(uuid)
          }}
          onFinish={e => {
            console.log(e)
          }}
          be100={be100}
          streamUUID={streamUUID}
        />
        {streamName && !isEmpty(event) && (
          <div className={classes.bottomButtons}>
            <Typography
              variant="h2"
              style={{
                color: 'white',
                alignSelf: 'center',
                marginTop: 8,
                marginBottom: 8
              }}
            >
              {streamName}
            </Typography>
            <Typography variant="h2" className={classes.eventTitle}>
              {event.auction_title}
            </Typography>

            {/* <LoaderButton
              variant="contained"
              color="primary"
              onClick={e => {
                if (!streaming) {
                  askToGoLive()
                } else {
                  stopStream()
                }
              }}
              classes={{ button: classes.goLiveButton }}
              working={liveRequested}
            >
              {streaming ? 'Stop Streaming' : 'Go Live'}
            </LoaderButton> */}
          </div>
        )}
        {event.auction_code && (
          <Fragment>
            <PubnubController
              onMessage={handlePubnub}
              channelName={`ember-event-${event.auction_code}`}
              ref={pubnub}
            />
            <PubnubController
              onPresence={handleStreamPresence}
              channelName={`streams-event-${event.auction_code}`}
              ref={streamPubnub}
            />
          </Fragment>
        )}
        <AllowLiveDialog
          open={allowLiveDialogOpen}
          close={bool => {
            setAllowLiveDialogOpen(false)
            if (bool) {
              handleCancelRequest()
              dispatch(
                makeStreamLive(requestStreamId, event.auction_code, {
                  live_now: 1
                })
              )
            } else {
              handleCancelRequest()
            }
          }}
          requestUser={requestUser}
        />
        <WaitingDialog
          open={waitingDialogOpen}
          close={() => {
            // console.log('closing')
            handleCancelRequest()
          }}
        />
        <SetNameDialog />
        <LoginDialog />
      </Box>
      <Box
        className={classes.liveBorderWrapper}
        style={{ width: be100 ? '100%' : 'calc(100vw - 200px)' }}
      >
        <Box
          className={classnames(classes.liveBorder, {
            [classes.liveBorderActive]: streaming
          })}
        />
      </Box>
    </Fragment>
  )
}

export default Stream



// WEBPACK FOOTER //
// ./src/pages/Stream/index.jsx